export const EBON_ACTIVATION_TYPE_ONLINE = 'ONLINE';
export const EBON_ACTIVATION_TYPE_OFFLINE = 'OFFLINE';
export const EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE = 'ONLINE_AND_OFFLINE';

export const EBON_TYPE_DOWNLOAD_CODE = 'DOWNLOAD_CODE';
export const EBON_TYPE_LINK_CODE = 'LINK_CODE';
export const EBON_TYPE_PRE_DOWNLOADED_LINK = 'PRE_DOWNLOADED_LINK';

export const ENTERPRISE_CARD_ENABLED = false;
export const ENTERPRISE_CARD_PARTNER_EBC_ID = 113;
export const ENTERPRISE_CARD_NAME = 'Eco Card';



// WEBPACK FOOTER //
// ./src/constants/ebon.js